<template>
  <div class="page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card min-height">
            <TableLoading v-if="unauthenticatedSampleOrder.publicId === '0'"/>
            <div v-else class="card-body">
              <div class="invoice-title">
                <h4 class="float-end font-size-16">Invoice # {{unauthenticatedSampleOrder.invoiceId}}</h4>
                <div class="mb-4">
                  <img
                      src="@/assets/images/KikkomanNameLogo.png"
                      alt="logo"
                      height="20"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong>From:</strong>
                    <p><br />Kikkoman East Africa <br/> Roshanmaer Place<br/> Lenana Road Kilimani  <br/></p>
                    Pin P051667186Z <br/>
                    P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                    <br />
                  </address>
                </div>
                <div class="col-6 text-sm-end">
                  <address >
                    <strong>Details:</strong>
                    <br />Delivery Date: {{unauthenticatedSampleOrder.deliveryDate}}
                  </address>
                </div>
              </div>
              <div class="p-2 mt-3">
                <h3 class="font-size-16">Sample Order summary</h3>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-light">
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product Name</th>
                    <th>Shipment</th>
                    <th class="text-sm-end">Quantity</th>
                  </tr>
                  </thead>
                  <tbody v-for="(item, index) in unauthenticatedSampleOrder.orderItems" :key="item.publicId">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{item.item.productName}}</td>
                    <td v-if="item.shipment">{{item.shipment.orderId}}</td>
                    <td v-else></td>
                    <td class="text-sm-end">{{item.itemCount}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config.json";
import {SINGLE_WAREHOUSE_SAMPLE_ORDER} from "@/gql/orders";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Warehouse Sample Order Detail",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading},
  name: "sample-order-details",
  data() {
    return {
      unauthenticatedSampleOrder: {
        publicId: '0',
        invoiceId: "",
        deliveryDate: "",
        orderItems: [{
          publicId: "",
          item: {
            productName: "",
          },
          shipment: {
            // orderId : "",
          },
          itemCount: "",
        }],
      }
    }
  },
  apollo: {
    unauthenticatedSampleOrder: {
      query: SINGLE_WAREHOUSE_SAMPLE_ORDER,
      variables(){
        return {
          id: this.$route.params.id,
          authToken: this.$route.params.authToken
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
